module.exports = __webpack_public_path__ + "img/373e8c914840686b4c435fcbc1278ded.png";